<div class="notificacoes-container">
  <!-- Botão de Notificação -->
  <div class="notificacao-trigger" (click)="toggleLista()" 
       nbTooltip="Notificações" 
       nbTooltipPlacement="bottom">
    <div class="notificacao-icon">
      <nb-icon icon="bell-outline"></nb-icon>
      <span class="badge" *ngIf="notificacoesNaoLidas > 0">{{ notificacoesNaoLidas }}</span>
    </div>
  </div>

  <!-- Lista de Notificações -->
  <div class="notificacoes-lista" *ngIf="mostrarLista" (click)="$event.stopPropagation()">
    <div class="notificacoes-header">
      <h4>Notificações</h4>
      <div class="header-actions">
        <button class="btn-marcar-todas"
                *ngIf="notificacoesNaoLidas > 0"
                (click)="marcarTodasComoLidas()">
          <nb-icon icon="checkmark-square-2-outline"></nb-icon>
          Marcar todos
        </button>
        <button class="btn-ir-admin"
                (click)="abrirNotificacaoAdmin()"
                nbTooltip="Ir para gestão de notificações"
                nbTooltipPlacement="bottom">
          <nb-icon icon="external-link-outline"></nb-icon>
          Ver todas na tela
        </button>
      </div>
    </div>

    <div class="notificacoes-content">
      <div class="conteudo-aba"
           nbInfiniteList
           [threshold]="250"
           (bottomThreshold)="carregarMaisPendentes()">
        <div *ngIf="notificacoesPendentes.length === 0" class="sem-notificacoes">
          <nb-icon icon="checkmark-circle-2-outline"></nb-icon>
          <p>Nenhuma notificação pendente</p>
        </div>

        <div *ngIf="notificacoesPendentes.length > 0"
             class="lista-notificacoes">
          <div *ngFor="let notificacao of notificacoesPendentesVisiveis" 
               class="notificacao-item"
               [class.nao-lida]="!notificacao.lida"
               [ngClass]="obterClasseTipo(notificacao.tipo)">
            
            <div class="notificacao-conteudo">
              <div class="notificacao-header">
                <div class="titulo-container">
                  <h5 class="notificacao-titulo">{{ notificacao.titulo }}</h5>
                  <div class="notificacao-badges">
                    <span class="badge-tipo" [ngClass]="'badge-' + notificacao.tipo">
                      {{ obterTipoBadge(notificacao.tipo) }}
                    </span>
                  </div>
                </div>
                <span class="notificacao-tempo">{{ formatarTempo(notificacao.dataHora) }}</span>
              </div>
              
              <div class="notificacao-mensagem">
                <p class="mensagem-principal">{{ notificacao.mensagem }}</p>
              </div>
              
              <!-- Informações detalhadas -->
              <div class="notificacao-detalhes" *ngIf="notificacao.observacao || notificacao.responsavelNotificacao">
                <div class="detalhe-item" *ngIf="notificacao.responsavelNotificacao">
                  <nb-icon icon="user-outline" class="detalhe-icon"></nb-icon>
                  <span class="detalhe-label">Responsável:</span>
                  <span class="detalhe-valor">{{ notificacao.responsavelNotificacao }}</span>
                </div>
                <div class="detalhe-item" *ngIf="notificacao.observacao">
                  <nb-icon icon="message-circle-outline" class="detalhe-icon"></nb-icon>
                  <span class="detalhe-label">Observação:</span>
                  <span class="detalhe-valor">{{ notificacao.observacao }}</span>
                </div>
              </div>
              
              <div class="notificacao-acoes" *ngIf="!notificacao.lida">
                <button class="btn-acao" (click)="marcarComoLida(notificacao); $event.stopPropagation()">
                  <nb-icon icon="checkmark-outline"></nb-icon>
                  Marcar como lido
                </button>
              </div>
            </div>
          </div>
          <div class="infinite-list-status" *ngIf="podeCarregarMaisPendentes">
            Role para carregar mais notificações pendentes...
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="notificacoes-footer">
      <button class="btn-ver-todas">Ver todas as notificações</button>
    </div> -->
  </div>
</div>

<!-- Overlay para fechar ao clicar fora -->
<div class="notificacoes-overlay" 
     *ngIf="mostrarLista" 
     (click)="mostrarLista = false">
</div>
